import { useLocation, useNavigate, useParams } from 'react-router';

const getShowAddRequestValue = (showAddRequest, search) => {
	const showAddRequestValue = showAddRequest || new URLSearchParams(search).get('showAddRequest');
	return showAddRequestValue !== null && showAddRequestValue.toLowerCase() === 'true';
};

const useShowAddRequest = () => {
	const { showAddRequest } = useParams();
	const navigate = useNavigate();
	const location = useLocation();

	const showAddRequestValue = getShowAddRequestValue(showAddRequest, location.search);

	const setShowAddRequest = (newValue) => {
		const searchString = new URLSearchParams(location.search);
		searchString.set('showAddRequest', newValue ? 'true' : 'false');

		navigate({
			pathname: location.pathname,
			search: searchString.toString(),
		});
	};

	return [showAddRequestValue, setShowAddRequest];
};

export default useShowAddRequest;
